const ADMIN_BASE = 'admin';

export const adminApi = (path: string) => `${ADMIN_BASE}${path}`;

export const environment = {
  production: false,

  firebaseConfig: {
    apiKey: 'AIzaSyAz5RvcfMnGkl238wMSt1WuYGOXFW2SzAY',
    authDomain: 'syncinns-7d68d.firebaseapp.com',
    projectId: 'syncinns-7d68d',
    storageBucket: 'syncinns-7d68d.firebasestorage.app',
    messagingSenderId: '199618996516',
    appId: '1:199618996516:web:4e201fe2b14ebf9c562bb1',
    measurementId: 'G-C4FDXCXMV7',
    vapid:
      'BNNR5falHhfFhF7GcyZBoJ2kbYC_E9LEiu9i1hSGR4kzsW4uUG2GByv-AIlRvf56eSuqKdpcbNBuvlDhfvNsWgA',
  },
  //mainapi path
  // API_URL: 'http://192.168.2.220:4001',
  // API_URL:'http://192.168.1.98:4001',
  API_URL: 'https://stagingbc.syncinns.com/',
  // API_URL: 'https://bridge.syncinns.com',
  // API_URL: 'https://stagingbc.syncinns.com/',
  E_SIGN_URL: 'https://esign.syncinns.com',

  screctKey: '$eyvhhdktee$ffehj9bjklal7je767893nnjsdhmksndf$wdfw#gdhkq@kfgdfgt',
  countriesApiUrl: 'https://restcountries.com/v3.1/all?fields=name,cca2,flags',
  //login
  LOGIN: adminApi('/auth/login'),
  REFRESH_TOKEN: adminApi('/auth/refresh-token'),
  FORGOT_PASSWORD: adminApi('/auth/forgot-password'),
  OTP_VARIFICATION: adminApi('/auth/verify-otp'),
  RESET_PASSWORD: adminApi('/auth/reset-password'),
  GET_PROFILE: adminApi('/users/profile-details'),
  UPDATE_PROFILE_DETAILS: 'users/update-profile',
  UPDATE_DEVICETOKEN: 'users/update-device-token',
  CHANGE_PASSWORD: 'users/change-password',

  UPLOADED_DOCUMENT: 'users/documents/upload',
  GET_DOCUMENT_LIST: adminApi('/documents/required'),
  //notification
  NOTIFICATION_LIST: 'users/notification',
  UNREAD_NOTIFICATION_COUNT: 'users/notificationCount',
  //GOOGLE MAP KEY
  GOOGLE_MAP_KEY: 'AIzaSyAsV8DLllskT26p40VVf_oex3fAswCc9cY',
  GETDOCUMENTREQUESTlIST: adminApi('/customer/document-requests-list'),
  GETUSERDOCUMENTLIST: adminApi('/customer/user'),
  DOCUMENT_REQUEST_APPROVAL: adminApi('/documents/:id/verify'),
  COUNTRY_LIST: 'country-list',
  USER_TYPE_DROPDOWN: adminApi('/user-type-dropdown'),
  ACCOUNT_MANAGER_DROPDOWN: adminApi('/staff/account-manager-dropdown'),
  DOCUMNET_SETUP_LIST: adminApi('/document-setup-list'),
  CREATE_USER: adminApi('/create-user'),
  UPDATE_USER: adminApi('/update-user'),
  DEPARTMENT_DROPDOWN: adminApi('/admin-department/dropdown'),
  ROLE_DROPDOWN: adminApi('/role/dropdown'),
  CREATE_LEAD: adminApi('/lead-entry'),
  LEADS_LIST: adminApi('/lead-entry'),
  LEAD_DETAILS: adminApi('/lead-entry'),
  SOFT_DELETE_LEAD_DETAILS: adminApi('/lead-entry'),
  UPDATE_LEAD: adminApi('/lead-entry'),
  ADD_LEAD_NOTES: adminApi('/lead-entry'),
  GET_ALL_LEAD_NOTE_DETAILS: adminApi('/lead-entry'),
  UPDATE_LEAD_NOTE_DETAILS: adminApi('/lead-entry'),
  DELETE_LEAD_NOTE_DETAILS: adminApi('/lead-entry'),
  LEAD_ACTIVITY_LOGS: adminApi('/lead-entry'),
  STAFF_LIST: adminApi('/staff/list'),
  STAFF_DETAILS: adminApi('/staff/staff-details'),
  CREATE_STAFF: adminApi('/staff/create-staff'),
  UPDATE_STAFF: adminApi('/staff/update-staff'),
  PRODUCT_LIST: adminApi('/product-plans/list'),
  PRODUCT_SOLUTION_LIST: adminApi('/product-plans/solution-list'),

  ALL_CUSTOMER_LIST: adminApi('/customers'),
  TRANSPORTERS_LIST: adminApi('/transporters'),
  VEHICLE_BOOKING_LIST: adminApi('/transporters/vehicle-bookings'),
  ALLOTMENT_HOLDERLIST: adminApi('/allotment-holders'),
  ROOM_RESERVATION_LIST: adminApi('/room-reservations'),
  MARKET_RESERVATION_LIST: adminApi('/market-reservations'),
  TRAVEL_AGENTS_LIST: adminApi('/travel-agents'),

  MARKETPLACE_LIST: adminApi('/marketplace/property-list'),
  APPROVED_MARKETPLACE_PROPERTY_LIST: adminApi('/marketplace/approved-property-list'),
  MARKETPLACE_UPDATE_STATUS: adminApi('/marketplace/property-action'),
  MARKETPLACE_PROPERTY_DETAILS: adminApi('/marketplace/marketplace-property-details'),
  MARKETPLACE_APPOVED_PROPERTY_DETAILS: adminApi('/marketplace/property-details'),
  MARKETPLACE_SIMILAR_PROPERTIES: adminApi('/pms/similiar-properties'),
  PROPERTY_DETAIL_RESERVATION_TRANSACTION: 'users/properties/property-details-list',

  //user documents setup
  GET_ALL_COUNTRY_DOCUMENTS: adminApi('/document-setup-list'),
  GET_ALL_COUNTRY_DOCUMENTS_DETAILS: adminApi('/documents/country-document'),
  CREATE_COUNTRY_DOCUMENTS: adminApi('/create-documents'),
  LIST_COUNTRY_DOCUMENTS: adminApi('/documents/document-types'),

  UPDATE_COUNTRY_DOCUMENTS: adminApi('/document-setup'),
  //PMS
  PMS_LIST: adminApi('/pms/property-list'),
  PMS_BOOKING_LIST: adminApi('/pms-booking/booking'),
  PMS_TRANSATION_FLOW_LIST: adminApi('/transaction/pms'),
  USER_SUBSCRIPTIONS: adminApi('/users'),
  USER_PROPERTIES: adminApi('/users'),
  USER_TICKET_STATUS_COUNT: adminApi('/users/tickets/status-count'),
  CHANGE_USER_PASSWORD: adminApi('/users/change-password'),

  // Vehicle
  VEHICLE_TRANSARCTION_FLOW_LIST: adminApi('/transaction/vehicle'),

  //room-view
  ADD_ROOM_VIEW: 'users/hotel-setting/room-views',
  GET_ROOM_VIEW_LIST: 'users/hotel-setting/room-views',
  ROOM_VIEWT_DETAIL: 'users/hotel-setting/room-views',
  ROOM_VIEW_UPDATE: adminApi('/room-view/roomViews'),
  DELETE_ROOM_VIEW: 'users/hotel-setting/room-views',
  STATUS_ROOM_VIEW: 'users/hotel-setting/room-views/toggle-status',
  GET_ALL_ROOMVIEW_LIST: 'users/hotel-setting/user-roomView-dropdown',
  USER_ADD_ROOM_VIEW: adminApi('/room-view/createRoomView'),
  USER_GET_ROOM_VIEW_LIST: adminApi('/room-view/roomViews'),
  USER_ROOM_VIEW_UPDATE: 'users/hotel-setting/user-roomView-update',
  USER_DELETE_ROOM_VIEW: 'users/hotel-setting/user-roomView-delete',
  USER_GET_DROPDOWN_ROOMVIEW_LIST: 'users/hotel-setting/room-views',

  //room-types
  ADD_ROOM_TYPES: 'users/hotel-setting/room-types',
  GET_ROOM_TYPES_LIST: adminApi('/room-types/roomTypes'),
  ROOM_TYPEST_DETAIL: 'users/hotel-setting/room-types',
  ROOM_TYPES_UPDATE: adminApi('/room-types/roomTypes'),
  DELETE_ROOM_TYPES: adminApi('/room-types/roomTypes'),
  STATUS_ROOM_TYPES: 'users/hotel-setting/room-types/toggle-status',
  GET_ALL_ROOMTYPE_LIST: 'users/hotel-setting/room-types-dropdown',
  CREATE_USER_ROOM_TYPE: adminApi('/room-types/createRoomType'),
  GET_ALL_ROOM_TYPES: 'users/hotel-setting/room-types',

  // Room Status
  ROOM_STATUS_LIST: adminApi('/room-status/list'),
  ROOM_STATUS_CREATE: adminApi('/room-status/create'),
  ROOM_STATUS_UPDATE: adminApi('/room-status/update'),
  ROOM_STATUS_DELETE: adminApi('/room-status/remove'),
  //amenities
  ADD_AMENITIES: adminApi('/hotel-setting/create-amenity'),
  GET_AMENITIES_LIST: adminApi('/hotel-setting/get-amenity'),

  GET_ALL_AMENITIES_LIST: 'users/hotel-setting/amenities-dropdown',
  AMENITIEST_DETAIL: 'users/hotel-setting/amenities',
  AMENITIES_UPDATE: adminApi('/hotel-setting/amenity-update'),
  DELETE_AMENITIES: adminApi('/hotel-setting/delete-amenity'),
  AMENITIES_DROPDOWN: 'users/hotel-setting/amenities-dropdown',
  GET_USER_SPECIFIC_AMENITIES_DROPDOWN: 'users/hotel-setting/get-amenities-dropdown',
  //facilities
  ADD_FACILITIES: adminApi('/hotel-setting/create-facility'),
  GET_FACILITIES_LIST: adminApi('/hotel-setting/get-facility'),
  GET_ALL_FACILITIES_LIST: 'users/hotel-setting/facilities-dropdown',
  FACILITIES_DETAIL: 'users/hotel-setting/facilities',
  FACILITIES_UPDATE: adminApi('/hotel-setting/facility-update'),
  DELETE_FACILITIES: adminApi('/hotel-setting/delete-facility'),
  FACILITIES_DROPDOWN: 'users/hotel-setting/facilities-dropdown',
  USER_SPECIFIC_FACILITIES_DROPDOWN: 'users/hotel-setting/get-facilities-dropdown',
  send_legal_agreement_authorization: '/api/esign/create',
  //profit report
  MARKET_PROFIT_REPORT: adminApi('/marketplace/profit-report'),

  // Commission
  USER_CREATE_COMMISSION: adminApi('/commission/create-setup'),
  GET_COMMISSION_HISTORY: adminApi('/commission/get-all-history'),
  UPDATE_COMMISSION: adminApi('/commission/update-user'),
  GET_USER_LIST: adminApi('/commission/user-commission-list'),
  UPDATE_STAFF_COMMISSION: adminApi('/commission/update-staff-commission'),
  GET_STAFF_LIST: adminApi('/commission/staff-commission-list'),
  //VAT Transaction LIST
  VAT_TRANSACTION_LIST: adminApi('/accounts/vat-report'),

  ADD_MEALS: adminApi('/meal/create'),
  GET_MEALS_LIST: adminApi('/meal/list'),
  MEALST_DETAIL: adminApi('/meal'),
  MEALS_UPDATE: adminApi('/meal'),
  DELETE_MEALS: adminApi('/meal'),

  PROPERTY_TYPE_DROPDOWN: adminApi('/property-type/drop-down-list'),
  PROPERTY_TYPE_CREATE: adminApi('/property-type/add'),
  PORPERTY_TYPE_LIST: adminApi('/property-type/list'),
  PROPERTY_TYPE_UPDATE: adminApi('/property-type'),
  PROPERTY_TYPE_DELETE: adminApi('/property-type'),
  PENDING_PROPERTY_LIST: adminApi('/pms/pending-property-list'),
  PROPERTY_APPROVAL_STATUS: adminApi('/pms/admin-approval'),

  MARKETPLACE_BOOKING_TYPE: adminApi('/pms/property-marketplace-setting'),
  MARKETPLACE_AUTO_BOOKING_ENABLED: adminApi('pms/toggle-property-marketplace-autobooking'),
  PROPERTY_ADDRESS_UPDATE: adminApi('/marketplace/marketplace-property-details'),
  GET_PENDING_DEPOSIT_LIST: adminApi('/deposit-balance/get-pending-fund-list'),
  FIRST_UPDATE_DEPOSIT_STATUS: adminApi('/deposit-balance/first-phase-approval'),
  FINAL_UPDATE_DEPOSIT_STATUS: adminApi('/deposit-balance/final-approval'),
  GET_ARRIVAL_REPOPRT: adminApi('/reservations/arrival-reports-upcoming'),
  GET_DEPOSIT_LIST: adminApi('/deposit-balance/get-list'),

  VECHICLE_TYPE_ADD: adminApi('/vehicle-types'),
  VECHICLE_TYPE_UPDATE: adminApi('/vehicle-types'),
  VEHICLE_TYPE_GET: adminApi('/vehicle-types'),
  VEHICLE_TYPE_DELETE: adminApi('/vehicle-types'),
  TICKET_CREATE: adminApi('/ticket/create'),
  TICKET_LIST: adminApi('/ticket/list'),
  TICKET_DETAILS: adminApi('/ticket'),
  COMMENT_CREATE: adminApi('/comment/create'),

  TICKET_STATUS_CHANGE: adminApi('/ticket/status'),
  ENQUERIES_GET: adminApi('/sales/get-enquiry'),

  BUSINESS_TYPE: adminApi('/sales/bussiness-types'),
  LEADS_GET: adminApi('/sales/leads'),
  GET_AFFILIATES_BUYER: adminApi('/customer/get-affiliates-buyer'),
  CREATE_OR_UPDATE_AFFILIATES_BUYER: adminApi('/customer/create-or-update-affiliates-buyer'),

  //shifts
  ADD_SHIFT: adminApi('/settings/shifts'),
  GET_SHIFT_LIST: adminApi('/settings/shifts'),
  SHIFT_DETAIL: adminApi('/settings/shifts'),
  SHIFT_UPDATE: adminApi('/settings/shifts'),
  DELETE_SHIFT: adminApi('/settings/shifts'),
  GET_ALL_SHIFT: adminApi('/settings/shifts-dropdown'),
  DELETE_WORKING_DAYS: adminApi('/settings/working-days'),

  //working days
  WORKING_DAYS: adminApi('/settings/working-days'),

  // DEMO MANAGEMENT
  GET_DEMO_SLOT_LIST: adminApi('/demo/list'),
  UPDATE_STATUS: adminApi('/demo'),

  //Slot Booking
  GET_SLOT_BOOKING_LIST: adminApi('/slot-booking/slots'),
  CREATE_SLOT_BOOKING: adminApi('/slot-booking/create-update-slots'),
  GET_DEMO_BY_ID: adminApi('/demo'),
  GET_DEMO_DETAIL_LIST: adminApi('/demo/detail-list'),
  UPDATE_DEMO_HOST_AND_NOTES: adminApi('/demo'),
  REQUEST_DEMO: adminApi('/demo/request-demo'),
  GET_DEMO_SLOTS: adminApi('/demo/get-slots'),

  //roles
  ADD_ROLES: adminApi('/role/add'),
  GET_ROLES_LIST: adminApi('/role/list'),
  GET_ROLES_ALL_LIST: adminApi('/role/dropdown'),
  ROLEST_DETAIL: adminApi('/role'),
  ROLES_UPDATE: adminApi('/role'),
  DELETE_ROLES: adminApi('/role'),
  GET_DEPARTMENT_WITH_ROLE: adminApi('/admin-department/with-roles'),

  //departments
  ADD_DEPARTMENT: adminApi('/admin-department/create'),
  GET_DEPARTMENT_LIST: adminApi('/admin-department/list'),
  DEPARTMENT_DETAIL: adminApi('/admin-department'),
  DEPARTMENT_UPDATE: adminApi('/admin-department'),
  DELETE_DEPARTMENT: adminApi('/admin-department'),
  GET_ALL_DEPARTMENT: adminApi('/admin-department/dropdown'),

  GET_INCENTIVE_REPORT: adminApi('/commission/report'),
  GET_ALL_STAFFS: adminApi('/staff/get-all-staffs'),
  GET_WITHDRAWAL_REQUEST_LIST: adminApi('/wallet/withdraw/manual-requests'),
  UPDATE_REQUEST: adminApi('/wallet/withdraw/manual'),

  SOLUTION_TYPE_LIST: adminApi('/solution-type/list'),
  SOLUTION_TYPE_ADD: adminApi('/solution-type/add'),
  SOLUTION_TYPE_EDIT: adminApi('/solution-type/edit'),
  SOLUTION_TYPE_DELETE: adminApi('/solution-type/del'),

  SUBSCRIPTION_LIST: adminApi('/product-plans/list'),
  SUBSCRIPTION_CREATE: adminApi('/product-plans/create'),
  SUBSCRIPTION_UPDATE: adminApi('/product-plans'),

  SUBSCRIBED_USER_LIST: 'users/subscription/list',
  SEND_CREDENTIAL_TO_SUBSCRIBER: 'users/subscription/send-credentials-to-subscriber',
  ADDON_FEATURE_CREATE: adminApi('/addon-feature/create'),
  ADDON_FEATURE_LIST: adminApi('/addon-feature/get-all-list'),
  ADDON_FEATURE_DETAILS: adminApi('/addon-feature/get-addon-feature-data'),
  ADDON_FEATURE_UPDATE: adminApi('/addon-feature/update'),
  ADDON_FEATURE_SORT_ORDER: adminApi('/addon-feature/update-sort-order'),
  ADDON_FEATURE_TOGGLE_STATUS: adminApi('/addon-feature'),
  ADDON_FEATURE_DELETE: adminApi('/addon-feature/delete'),
  ADDON_PURCHASE_HISTORY: adminApi('/addon-feature/addon-purchases'),
  ONBOARDED_USERS_STAFF: adminApi('/staff/user-list-onboarded'),
  STAFF_DASHBOARD: adminApi('/staff/staff-dashboard'),
  ADMIN_DASHBOARD: adminApi('/dashboard'),
  DELETE_USER_PROPERTY_DATA: adminApi('/pms/property-data/hard-delete')
};
